import React from 'react'
import ReactQuill from 'react-quill'
import PropTypes from 'prop-types'
import './QuillEditor.scss'
import '../../../../node_modules/react-quill/dist/quill.snow.css'

class QuillEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = { editorHtml: props.editorHtml, theme: 'snow' }
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.state.editorHtml !== prevProps.editorHtml) {
      this.props.onEditorChange(this.state.editorHtml)
    }
  }

  handleChange(html) {
    this.setState({ editorHtml: html })
  }

  render() {
    const modules = {
      toolbar: [['bold', 'italic', 'underline'], [{ list: 'bullet' }]],
      clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false
      }
    }
    const formats = ['bold', 'italic', 'underline', 'list']

    return (
      <div className="quill-container" data-testid="quill-content">
        <ReactQuill
          theme={this.state.theme}
          onChange={this.handleChange}
          value={this.state.editorHtml}
          modules={modules}
          formats={formats}
          bounds={'.quill-container'}
          placeholder={this.props.placeholder}
        />
      </div>
    )
  }
}

QuillEditor.propTypes = {
  placeholder: PropTypes.string,
  editorHtml: PropTypes.string,
  onEditorChange: PropTypes.func
}

export default QuillEditor
